import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaInstagram, FaApple } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-[#0b0c15] border-t-4 border-[#2d2d2d] py-12 mt-auto">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">

                    {/* Brand */}
                    <div className="text-center md:text-left">
                        <h3 className="text-2xl text-[#ff0055] font-vt323 uppercase tracking-widest mb-2">Blue Pixelated</h3>
                        <p className="text-gray-400 font-vt323 text-lg">Turn your world into 8-bit art.</p>
                    </div>

                    {/* Stores */}
                    <div className="flex space-x-6">
                        <a href="https://apps.apple.com/us/app/blue-pixelated/id6756602667" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#ff0055] transition-colors text-3xl"><FaApple /></a>
                    </div>

                    {/* Socials & Links */}
                    <div className="flex flex-col items-center md:items-end space-y-4">
                        <div className="flex space-x-6">
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#ff0055] transition-colors text-2xl"><FaTwitter /></a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#ff0055] transition-colors text-2xl"><FaInstagram /></a>
                        </div>
                        <div className="flex space-x-4">
                            <Link to="/privacy" className="text-gray-400 hover:text-white font-vt323 text-lg uppercase transition-colors">Privacy Policy</Link>
                            <span className="text-gray-600">|</span>
                            <Link to="/contact" className="text-gray-400 hover:text-white font-vt323 text-lg uppercase transition-colors">Contact Us</Link>
                        </div>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t-2 border-[#1f212e] text-center">
                    <p className="text-gray-500 font-vt323 text-lg">
                        &copy; {new Date().getFullYear()} Blue Pixelated. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
